export const LOAD_CHATROOMS_AND_MESSAGES = "LOAD_CHATROOMS_AND_MESSAGES";
export const LOAD_ADMIN_CHATROOMS_AND_MESSAGES =
	"LOAD_ADMIN_CHATROOMS_AND_MESSAGES";
export const ADD_SENT_MESSAGE = "ADD_SENT_MESSAGE";
export const ADD_RECEIVED_MESSAGE = "ADD_RECEIVED_MESSAGE";
export const ADD_NEW_CHATROOM = "ADD_NEW_CHATROOM";
export const MARK_MESSAGES_AS_SEEN = "MARK_MESSAGES_AS_SEEN";
export const ADD_TEMP_CHATROOM = "ADD_TEMP_CHATROOM";
export const REPLACE_TEMP_CHATROOM = "REPLACE_TEMP_CHATROOM";
